{
  "de": {
    "analytics": {
      "labels": {
        "allUnits": "Alle Einheiten",
        "click_seen_by": "Klicken für mehr Informationen",
        "click_shared_with": "Klicken, um zu sehen, welche Kunden dies gesehen haben",
        "deleted": "Gelöscht",
        "deleted_item": "Dieser Eintrag wurde gelöscht und ist nicht mehr anklickbar",
        "noCustomers": "Dieser Ebene sind noch keine Kunden zugewiesen.",
        "noCustomersSeen": "Noch kein Kunde hat dies gesehen.",
        "noCustomersUnseen": "Alle Kunden haben dies gesehen.",
        "noUnitAccess": "Kein Einheitszugriff",
        "notSeen": "Nicht gesehen ({number})",
        "seen": "Gesehen ({number})",
        "seenAt": "Gesehen am {date}",
        "seenBy": "Gesehen von",
        "seen_by_all": "Von allen gesehen. Klicken, um zu sehen, wer es gesehen hat.",
        "sharedWithMultipleUnits": "Mit keiner Einheit in {level_name} geteilt | Mit 1 Einheit in {level_name} geteilt | Mit {units_count} Einheiten in {level_name} geteilt",
        "sharedWithUnit": "Geteilt mit {unit_name}",
        "units": "Keine Einheit | Eine Einheit | {count} Einheiten",
        "unseenOfTotal": "{unseen} von {total} haben es noch nicht gesehen",
        "views": "Aufrufe",
        "viewsCount": "Keine Aufrufe | 1 Aufruf | {count} Aufrufe",
        "whoSeenAnnouncement": "Wer hat diese Neuigkeit gesehen"
      }
    }
  }
}
